import axios, { AxiosInstance } from "axios"

import {
  ErrorHandler,
  IHttpService,
  RequestConfig,
  RequestHandler,
  ResponseHandler,
  TokenGetter,
  UrlMaker
} from "../types"

export class AxiosService implements IHttpService {

  client: AxiosInstance
  makeUrl: UrlMaker

  constructor(getToken: TokenGetter, makeUrl: UrlMaker) {
    this.makeUrl = makeUrl
    this.client = axios.create({
      headers: {
        Authorization: "Bearer " + getToken(),
        "Content-Type": "application/json;charset=UTF-8",
      }
    })
  }

  get = <TResponse>(url: string, config?: RequestConfig | undefined): Promise<TResponse> => {
    return this.client.get(this.makeUrl(url), config)
  }

  post = <TResponse>(url: string, data?: any, config?: RequestConfig | undefined): Promise<TResponse> => {
    return this.client.post(this.makeUrl(url), data, config)
  }

  put = <TResponse>(url: string, data?: any, config?: RequestConfig | undefined): Promise<TResponse > => {
    return this.client.put(this.makeUrl(url), data, config)
  }

  delete = <TResponse>(url: string, config?: RequestConfig | undefined): Promise<TResponse> => {
    return this.client.delete(this.makeUrl(url), config)
  }

  patch = <TResponse>(url: string, data?: any, config?: RequestConfig | undefined): Promise<TResponse> => {
    return this.client.patch(this.makeUrl(url), data, config)
  }

  addRequestPreprocessor = (handler?: RequestHandler): void => {
    this.client.interceptors.request.use(handler)
  }

  addResponseHandler = (handler?: ResponseHandler, errorHandler?: ErrorHandler): void => {
    this.client.interceptors.response.use(handler, errorHandler)
  }
}
